module.exports = __webpack_public_path__ + "img/com.f78dc87d.png";